import { useAdminEmailMessage } from "../../hooks/useAdminEmailMessage";
import type { AdminEmailSelectedMessageProps } from "../../models/admin-email.models";
import AdminEmailMessageBody from "./AdminEmailMessageBody";

// Adapt the current inbox selection to a body request while the body component receives prepared content only.
const AdminEmailSelectedMessage = ({ mailboxId, messageId }: AdminEmailSelectedMessageProps) => {
  const message = useAdminEmailMessage(mailboxId, messageId);

  return <AdminEmailMessageBody {...message} />;
};

export default AdminEmailSelectedMessage;
